import React from 'react';
import Model, { Providers } from '@tripian/model';
import classes from './StorageInfoBox.scss';
import CloseIconButton2 from '../base/Button/Icons/CloseIconButton2/CloseIconButton2';
import { ArrowRight, Star3 } from '../base/Svg/Icons';

interface IStorageInfoBox {
  storage: Providers.RadicalStorage.StorageItem;
  onDetailsClick: (storage: Providers.RadicalStorage.StorageItem) => void;
  onClose?: () => void;
  onAddToItinerary: (storage: Providers.RadicalStorage.StorageItem) => void;
  t: (value: Model.TranslationKey) => string;
}

const StorageInfoBox: React.FC<IStorageInfoBox> = ({ storage, onDetailsClick, onClose, onAddToItinerary, t }) => {
  return (
    <div className={classes.storageInfoBox}>
      <div className={classes.storageInfoContent}>
        {onClose && (
          <div className={classes.closeButton}>
            <CloseIconButton2 fill="var(--primary-color)" clicked={onClose} />
          </div>
        )}
        <div className={classes.storageHeader}>
          <div className={classes.storageIcon}></div>
          <span className={classes.storageType}>{storage.type}</span>
        </div>

        <div className={classes.storageName}>{storage.name}</div>

        {storage.rating && (
          <div className={classes.storageRating}>
            <Star3 />
            <span>
              {storage.rating} ({storage.ratingCount || 0})
            </span>
          </div>
        )}

        <div className={classes.buttonContainer}>
          <button
            type="button"
            className={classes.addToItineraryBtn}
            onClick={() => {
              onAddToItinerary(storage);
            }}
          >
            {t('trips.myTrips.itinerary.step.addToItinerary.submit.add')}
          </button>
          <button className={classes.storageDetailsBtn} onClick={() => onDetailsClick(storage)}>
            {t('seeDetails')}
            <ArrowRight className={classes.arrowIcon} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default StorageInfoBox;
